/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessRequestDetail } from './AccessRequestDetail';
import {
    AccessRequestDetailFromJSON,
    AccessRequestDetailFromJSONTyped,
    AccessRequestDetailToJSON,
} from './AccessRequestDetail';

/**
 * 
 * @export
 * @interface GetAccessRequestsMe200ResponseAllOf
 */
export interface GetAccessRequestsMe200ResponseAllOf {
    /**
     * 
     * @type {Array<AccessRequestDetail>}
     * @memberof GetAccessRequestsMe200ResponseAllOf
     */
    result: Array<AccessRequestDetail>;
}

/**
 * Check if a given object implements the GetAccessRequestsMe200ResponseAllOf interface.
 */
export function instanceOfGetAccessRequestsMe200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetAccessRequestsMe200ResponseAllOfFromJSON(json: any): GetAccessRequestsMe200ResponseAllOf {
    return GetAccessRequestsMe200ResponseAllOfFromJSONTyped(json, false);
}

export function GetAccessRequestsMe200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccessRequestsMe200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(AccessRequestDetailFromJSON)),
    };
}

export function GetAccessRequestsMe200ResponseAllOfToJSON(value?: GetAccessRequestsMe200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(AccessRequestDetailToJSON)),
    };
}

